module.exports = __webpack_public_path__ + "img/meme_29.854c9ddb.jpg";